import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _toConsumableArray from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/** @jsxImportSource @emotion/react */
import { useInfiniteQuery } from "@tanstack/react-query";
import { getProductReviews } from "@vc-workspace/data-adapter";
import { TailwindColors } from "@vc-workspace/utils-colors";
import { Typography } from "@vc-workspace/utils-typography";
import StarIcon from '@mui/icons-material/Star';
import { UtilsSeparator } from "@vc-workspace/utils-separator";
import { DIMENSIONS } from "@vc-workspace/utils-dimens";
import ReviewListItem from "../review-list-item/review-list-item";
import { UtilsInfiniteScroll } from "@vc-workspace/utils-infinite-scroll";
import Skeleton from '@mui/material/Skeleton';
import ProductOwnReviewBanner from "../product-own-review-banner/product-own-review-banner";
import { PageTypes } from "@vc-workspace/utils-constants";
export function ProductReviewsSection(props) {
  var _props$reviewData, _props$reviewData2, _data$pages$2, _data$pages;

  var _useInfiniteQuery = useInfiniteQuery(["getProductReview", props.sia.itemDetail.usId], function (_ref) {
    var _ref$pageParam = _ref.pageParam,
        pageParam = _ref$pageParam === void 0 ? 0 : _ref$pageParam;
    return getProductReviews(props.sia.itemDetail.usId, pageParam);
  }, {
    enabled: true
  }),
      data = _useInfiniteQuery.data,
      isLoading = _useInfiniteQuery.isLoading,
      isFetchingNextPage = _useInfiniteQuery.isFetchingNextPage,
      fetchNextPage = _useInfiniteQuery.fetchNextPage;

  var displayReviews = [];

  if (data && data.pages) {
    data.pages.forEach(function (page) {
      displayReviews = [].concat(_toConsumableArray(displayReviews), _toConsumableArray(page.reviews));
    });
  }

  var onNextPage = function onNextPage() {
    var _data$pages$;

    if (data && data.pages && displayReviews.length < (data === null || data === void 0 ? void 0 : (_data$pages$ = data.pages[0]) === null || _data$pages$ === void 0 ? void 0 : _data$pages$.totalReviewsCount)) {
      fetchNextPage({
        pageParam: data.pages.length
      });
    }
  };

  return _jsxs(_Fragment, {
    children: [_jsxs("div", {
      className: "md:flex items-center justify-between",
      children: [_jsxs("div", {
        children: [_jsx(Typography, {
          type: "Headline_H3",
          color: TailwindColors.grey[900],
          className: props.context.isMobileView ? "px-4" : "",
          semi_bold: true,
          children: "Product Reviews & Ratings"
        }), _jsxs("div", {
          className: "flex items-center ".concat(props.context.isMobileView ? "px-4 pt-2" : "pt-4"),
          children: [_jsx(Typography, {
            type: props.context.isMobileView ? "SubHeading1" : "Headline_H3",
            color: TailwindColors.grey[800],
            semi_bold: true,
            children: (_props$reviewData = props.reviewData) === null || _props$reviewData === void 0 ? void 0 : _props$reviewData.averageRating
          }), _jsx(Typography, {
            type: "Caption",
            color: TailwindColors.amber[500],
            className: "pl-px",
            children: _jsx(StarIcon, {
              fontSize: "small"
            })
          }), _jsx(Typography, {
            type: "Body1",
            color: TailwindColors.grey[400],
            className: "px-1",
            children: "\u2022"
          }), _jsx(Typography, {
            type: props.context.isMobileView ? "SubHeading1" : "Headline_H3",
            color: TailwindColors.grey[700],
            bold: true,
            children: (_props$reviewData2 = props.reviewData) === null || _props$reviewData2 === void 0 ? void 0 : _props$reviewData2.totalRatings
          }), _jsx(Typography, {
            type: props.context.isMobileView ? "Body1" : "SubHeading1",
            color: TailwindColors.grey[600],
            className: "pl-1",
            children: "Ratings"
          })]
        })]
      }), _jsx(ProductOwnReviewBanner, {
        sia: props.sia,
        context: props.context
      })]
    }), _jsx(UtilsSeparator, {
      seperatorHeight: DIMENSIONS.px_4,
      color: TailwindColors.grey[100],
      borderRadius: DIMENSIONS.px_2,
      spacingTop: props.context.isMobileView ? DIMENSIONS.px_8 : DIMENSIONS.px_20
    }), displayReviews.map(function (reviewItem) {
      return _jsxs(_Fragment, {
        children: [_jsx(ReviewListItem, {
          context: props.context,
          reviewDetails: reviewItem,
          wrapperClassName: props.context.isMobileView ? "px-4" : "",
          sourceType: PageTypes.PRODUCT_REVIEW_PAGE,
          sourceName: PageTypes.PRODUCT_REVIEW_PAGE
        }), _jsx(UtilsSeparator, {
          seperatorHeight: DIMENSIONS.px_2,
          color: TailwindColors.grey[100],
          borderRadius: DIMENSIONS.px_2
        })]
      });
    }), displayReviews.length < (data === null || data === void 0 ? void 0 : (_data$pages$2 = data.pages[0]) === null || _data$pages$2 === void 0 ? void 0 : _data$pages$2.totalReviewsCount) || isLoading ? _jsx(UtilsInfiniteScroll, {
      currPage: (data === null || data === void 0 ? void 0 : (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.length) || 0,
      callback: onNextPage,
      customLoaderLayout: _jsxs(_Fragment, {
        children: [_jsxs("div", {
          className: "mt-6",
          children: [_jsxs("div", {
            className: "flex items-center justify-between",
            children: [_jsx(Skeleton, {
              animation: "wave",
              width: "35%",
              height: 32
            }), _jsx(Skeleton, {
              animation: "wave",
              width: "20%",
              height: 32
            })]
          }), _jsx(Skeleton, {
            animation: "wave",
            height: 120
          })]
        }), _jsxs("div", {
          className: "mt-6",
          children: [_jsxs("div", {
            className: "flex items-center justify-between",
            children: [_jsx(Skeleton, {
              animation: "wave",
              width: "35%",
              height: 32
            }), _jsx(Skeleton, {
              animation: "wave",
              width: "20%",
              height: 32
            })]
          }), _jsx(Skeleton, {
            animation: "wave",
            height: 120
          })]
        }), _jsxs("div", {
          className: "mt-6",
          children: [_jsxs("div", {
            className: "flex items-center justify-between",
            children: [_jsx(Skeleton, {
              animation: "wave",
              width: "35%",
              height: 32
            }), _jsx(Skeleton, {
              animation: "wave",
              width: "20%",
              height: 32
            })]
          }), _jsx(Skeleton, {
            animation: "wave",
            height: 120
          })]
        })]
      })
    }) : null]
  });
}
export default ProductReviewsSection;